import { CURRENT_USER_COMPANY, CURRENT_USER_ROLE } from '../../hooks/useLogin';
import Navigator, { NAVIGATOR_HEIGHT } from '../../components/Navigator';
import { useEffect, useState, Fragment } from 'react';
import LoginBg from '../../assets/login-background.png';
import {
  Grid,
  Box,
  Typography,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { courseTitle, courseActions, courseDetail } from './styles';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { useHistory, useParams } from 'react-router-dom';
import Copyright, { COPYRIGHT_HEIGHT } from '../../components/Copyright';
import { CSVLink } from 'react-csv';
import { setTimeZone } from '../../hooks/useTimeZone';
import { createTheme, ThemeProvider, responsiveFontSizes } from '@mui/material/styles';
import MUIDataTable, { type MUIDataTableOptions } from 'mui-datatables';
import { getAllCompanies, getCourse, getCourse2User, getUser, sendCourseReminderEmail } from '../../api/apis';
import { type Company } from 'src/utils/type';
declare module '@mui/material/styles' {
  type Components = Record<string, any>;
}

export const CourseReportListPage = () => {
  // useLogin()
  const { t } = useTranslation();
  const currentRole = sessionStorage.getItem(CURRENT_USER_ROLE);
  const currentCompany = sessionStorage.getItem(CURRENT_USER_COMPANY);
  const history = useHistory();
  const { id } = useParams<{ id: string; }>();
  const [courseData, setCourseData] = useState<any>({});
  const [userData, setUserData] = useState<any>([]);
  const [filterUserData, setFilterUserData] = useState<any>([]);
  const [courseHistory, setCourseHistory] = useState<any>([]);
  const [quiz, setQuiz] = useState<boolean>(false);
  const [companies, setCompanies] = useState<Company[]>([]);

  useEffect(() => {
    if (id) {
      setQuiz(id.endsWith('Q')); // A quiz course id ends with letter Q
    }
  }, [id]);

  useEffect(() => {
    if (companies) {
      const companyColIndex = columns.findIndex((column) => column.name === 'company');
      const departmentColIndex = columns.findIndex((column) => column.name === 'department');
      setColumns((prev) => {
        prev[companyColIndex].options.filterOptions.names = companies.map((company) => company.company_name);
        prev[departmentColIndex].options.filterOptions.names = companies.map((company) => company.departments).flat();
        return [...prev];
      });
    }
  }, [companies]);

  const uniqueValuesSet = new Set();

  const getDepartUser = (courseData: any) => {
    setUserData([]);
    setFilterUserData([]);
    // Get companies
    getAllCompanies().then((res) => {
      setCompanies(res.data.company);
    });

    if (currentRole === 'platform-admin') {
      courseData.course.mandatory.forEach((department: any) => {
        getUser({ department }).then(departmentUser => {
          const email = Object.assign({}, departmentUser.data.user);
          getUserInfo(email);
        });
      });
    }
    if (currentRole === 'department-admin') {
      getAllCompanies().then((res) => {
        setCompanies(res.data.company);
        const currentCompanyDepartments = res.data.company.find((company: Company) => company.cid === currentCompany)?.departments || [];
        const allowedDepartments = currentCompanyDepartments?.filter((department: string) => courseData.course.mandatory.includes(department));
        allowedDepartments.forEach((department: any) => {
          getUser({ department }).then(departmentUser => {
            const email = Object.assign({}, departmentUser.data.user);
            getUserInfo(email);
          });
        });
      });
    }
  };

  const getCourseDepartments = async () => {
    const getCourseData = await getCourse({ courseid: id });
    if (getCourseData.data?.course?.score_pass !== '1' && columns.length === 6) {
      setColumns((prevState) => {
        const reminderCol = prevState.pop();
        return [...prevState, {
          name: 'score',
          label: t('Score'),
          options: {
            filter: false,
            sort: true,
          },
        }, reminderCol];
      });
    }

    setColumns((prevState) => {
      const arr = [...prevState];
      arr[2].options.filterOptions.names = getCourseData.data.course.mandatory; // department field
      return arr;
    });

    getDepartUser(getCourseData.data);
    setCourseData(getCourseData.data);
  };

  const getCourseHistory = async () => {
    const history = await getCourse2User({ courseid: id });
    setCourseHistory(history.data);
  };

  const getUserInfo = (email: ObjectConstructor) => {
    const mainData = Object.entries(email);
    if (mainData.length > 0) {
      const emails = [];
      Object.keys(mainData).forEach((key: any) => {
        const data: any = mainData[key][1];
        emails.push(data);
      });
      getUser({ email: emails.join('!') })
        .then(getUserData => {
          let users = getUserData.data.user;
          if (!Array.isArray(users)) {
            users = [users];
          }
          const userData = []; const filterUserData = [];
          users.forEach((user: { status: string; email: string; }) => {
            if (user?.status === 'active') {
              userData.push(user);
            }
            const isPresentInSet = uniqueValuesSet.has(user.email);
            uniqueValuesSet.add(user.email);
            if (!isPresentInSet && user.status === 'active') {
              filterUserData.push(user);
            }
          });
          setUserData((arr: any) => [...arr, ...userData]);
          setFilterUserData((arr: any) => [...arr, ...filterUserData]);
        });
    }
  };

  useEffect(() => {
    if (id) {
      getCourseDepartments();
      getCourseHistory();
    }
  }, []);

  const uniqueValuesSet1 = new Set();
  const arr1 = userData;

  const filteredDuplicateUser = arr1.filter((user: any) => {
    if (user.role === 'platform-admin') return false;
    if (user.role === 'department-admin') return false;
    const isPresentInSet = uniqueValuesSet1.has(user.email);
    uniqueValuesSet1.add(user.email);
    return !isPresentInSet;
  });

  const calculatePercentage = () => {
    const scorePass = 60;
    let percentage: any = 0;
    let passingRate: any = 0;
    let averageScore: any = 0;

    const data = {
      value: 0,
      userPass: 0,
      totalScore: 0,
    };
    if (filteredDuplicateUser instanceof Array && filteredDuplicateUser.length > 0) {
      filteredDuplicateUser.forEach(user => {
        if (courseHistory && courseHistory.course2user instanceof Array) {
          courseHistory.course2user.every((report: any) => {
            if (user && report.uid === user.uid) {
              data.value = data.value + 1;
              data.totalScore = data.totalScore + parseInt(report.score);
              if (report.score > scorePass) {
                data.userPass = data.userPass + 1;
              }
              return false;
            }
            return true;
          });
        }
      });
      percentage = (data.value * 100) / filteredDuplicateUser.length;
      passingRate = (data.userPass * 100) / data.value;
      averageScore = data.totalScore / data.value;
    }
    averageScore = isNaN(averageScore.toFixed(0)) ? 0 : averageScore.toFixed(0);

    return (
      <Fragment>
        <div style={{ width: 200, height: 200, backgroundColor: 'white', borderRadius: '50%' }}>
          <CircularProgressbarWithChildren
            value={percentage.toFixed(1)}
            styles={buildStyles({
              pathColor: '#80B6E0',
              backgroundColor: '#80B6E0',
            })}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#006EC2' }}>
              <strong style={{ fontSize: '40px' }}>{percentage.toFixed(1)}%</strong>
              <span style={{ fontSize: '18px' }}>{t('Completed rate')}</span>
            </div>
          </CircularProgressbarWithChildren>
        </div>
        <div className="course-detail-rating">
          {data.value}/{filteredDuplicateUser.length}
        </div>
        {quiz && (
          <>
            <div className="course-detail-score">{t('Average score')}: {averageScore}</div>
            <div className="course-detail-passing">{t('Passing rate')}: {isNaN(passingRate) ? '0' : passingRate.toFixed(1)}%</div>
          </>
        )}
      </Fragment>
    );
  };

  function SortReportArray (x: any, y: any) {
    const xId = x.employeeId ? x.employeeId : '-';
    const yId = y.employeeId ? y.employeeId : '-';
    if (xId < yId) {
      return -1;
    }
    if (xId > yId) {
      return 1;
    }
    return 0;
  }

  const checkDuplicateUser = (user: any) => {
    let duplicateUser: string = '';
    userData.forEach((data: any) => {
      if (data.email === user.email) {
        if (duplicateUser) {
          duplicateUser = `${duplicateUser}, ${data.department as string}`;
        } else {
          duplicateUser = data.department;
        }
      }
    });
    return duplicateUser.replace(/!/g, ',');
  };
  const handleExportAllReport = () => {
    const csvData: Array<{
      courseName: any;
      employeeId: any;
      division: any;
      score: string;
      duration: string;
      starttime: string;
      completedTime: string;
    }> = [];
    filteredDuplicateUser.forEach((user: any) => {
      if (user?.uid) {
        const data = {
          courseName: courseData.course?.category1,
          employeeId: user.email.split('@')[0] ? user.email.split('@')[0] : '-',
          division: checkDuplicateUser(user),
          score: '-',
          duration: '-',
          starttime: '-',
          completedTime: '-',
        };
        if (courseHistory && courseHistory.course2user instanceof Array) {
          const report = courseHistory.course2user.find((report: any) => report.uid === user.uid);
          if (report) {
            data.score = report.score;
            data.duration = report.duration;
            data.starttime = setTimeZone(report.starttime);
            data.completedTime = setTimeZone(report.endtime);
          }
        }
        csvData.push(data);
      }
    });

    const headers = quiz
      ? [
          { label: t('Course Name'), key: 'courseName' },
          { label: t('Email'), key: 'employeeId' },
          { label: t('Division'), key: 'division' },
          { label: t('Score'), key: 'score' },
          { label: t('Duration'), key: 'duration' },
          { label: t('Start Time'), key: 'starttime' },
          { label: t('Completed Time'), key: 'completedTime' },
        ]
      : [
          { label: t('Course Name'), key: 'courseName' },
          { label: t('Email'), key: 'employeeId' },
          { label: t('Division'), key: 'division' },
          { label: t('Duration'), key: 'duration' },
          { label: t('Start Time'), key: 'starttime' },
          { label: t('Completed Time'), key: 'completedTime' },
        ];

    const csvReport = {
      data: csvData.sort(SortReportArray),
      headers,
      filename: `course_report_${id}.csv`,
    };

    return (
      <CSVLink {...csvReport}>
        {/* <Button className="course-detail-report" variant="contained">
          Export report
        </Button> */}
      </CSVLink>
    );
  };

  const filteredArr = filterUserData.filter((user: { role: string; }) => {
    if (user.role === 'platform-admin') return false;
    if (user.role === 'department-admin') return false;
    return true;
  }).map((user: { company: string; company_id: string; email: string; uid: any; score: any; endtime: any; starttime: any; sendReminder: React.ReactNode; }) => {
    let data: { score: any; endtime: any; starttime: any; };
    if (courseHistory && courseHistory.course2user instanceof Array) {
      data = courseHistory.course2user.find((report: any) => report.uid === user.uid);
      if (data) {
        user.score = data.score;
        user.endtime = data.endtime;
        user.starttime = data.starttime;
      }
    }
    const userCompany = companies.find((company: { cid: string; }) => company.cid === user.company_id);
    user.company = userCompany?.company_name;
    user.sendReminder = (
      <Button
        sx={{
          height: '34px',
          textTransform: 'capitalize',
        }}
        variant="contained"
        onClick={async () => await sendCourseReminderEmail({
          courseid: id,
          users: user.email,
        })}>{t('Send')}</Button>);
    return user;
  });
  filteredArr.sort((a: { uid: number; }, b: { uid: number; }) => {
    if (a.uid > b.uid) return 1;
    else if (a.uid === b.uid) return 0;
    return -1;
  });

  const sendReminderEmail = () => {
    sendCourseReminderEmail({
      courseid: id,
      users: filteredArr.map(item => item.email).join('!'),
    });
  };
  const options: MUIDataTableOptions = {
    filter: true,
    responsive: 'vertical',
    filterType: 'multiselect',
    fixedHeader: true,
    print: false,
    viewColumns: false,
    fixedSelectColumn: false,
    tableBodyHeight: '700px',
    selectableRows: 'none',
    download: false,
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 30, 50, 100],
    textLabels: {
      body: {
        noMatch: 'Now loading user list',
      },
      filter: {
        all: t('All'),
        title: t('FILTERS'),
        reset: t('RESET'),
      },
      pagination: {
        next: t('Next Page'),
        previous: t('Previous Page'),
        rowsPerPage: t('Rows per page') + ':',
        displayRows: t('of'),
      },
    },
    onFilterChange (changedColumn, filterList, type, changedColumnIndex, displayData) {
      if (changedColumn === 'company') {
        const selectedCompanies = companies.filter((company: Company) => filterList[changedColumnIndex].includes(company.company_name));
        const availableDepartments = selectedCompanies.map((company: Company) => company.departments).flat();
        setColumns(cols => {
          const departmentIndex = cols.findIndex((col: any) => col.name === 'department');
          cols[departmentIndex].options.filterOptions.names = availableDepartments;
          return [...cols];
        });
      }
    },
  };
  let theme = createTheme();
  theme = responsiveFontSizes(theme);
  function getMuiTheme () {
    return createTheme({
      components: {
        MuiTableCell: {
          styleOverrides: {
            root: {
              fontSize: '16px',
              lineHeight: '22px',
            },
            head: {
              background: '#006EC2 !important',
              color: '#fff !important',
              fontSize: '16px',
              '& .MUITableSortLabel-icon': { color: '#fff !important' },
            },
            footer: {
              background: '#fff !important',
            },
            stickyHeader: {
              color: '#fff !important',
            },
          },
        },
        MuiTableRow: {
          styleOverrides: {
            root: {
              '&:nth-of-type(odd)': {
                background: '#E5F0F9',
              },
              '&:nth-of-type(even)': {
                background: '#F5F9FD',
              },
              // hide last border
              '&:last-child td, &:last-child th': {
                border: 0,
              },
            },
            head: {
              background: '#006EC2 !important',
              color: '#fff !important',
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              'div div': {
                color: '#fff !important',
              },
            },
          },
        },
      },
    });
  }

  const [columns, setColumns] = useState([
    {
      name: 'uid',
      label: 'UID',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'company',
      label: t('Company'),
      options: {
        sort: true,
        filter: true,
        filterOptions: {
          names: [],
        },
      },
    },
    {
      name: 'department',
      label: t('Department'),
      options: {
        filter: true,
        sort: true,
        filterOptions: {
          names: [],
          logic: (department: string, filters: any) => {
            if (filters.length) {
              const departments = department.split('!');
              const filteredArray = departments.filter(value => filters.includes(value));
              return !filteredArray.length;
            }
            return false;
          },
        },
        customBodyRender: (value: any) => {
          return (
            <div style={{ width: '150px', wordWrap: 'break-word' }}>
              {value ? value.replaceAll('!', ', ') : '-'}
            </div>
          );
        },
      },
    },
    {
      name: 'starttime',
      label: t('Start Time'),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any) => {
          return value ? setTimeZone(value, 'Hongkong') : '-';
        },
      },
    },
    {
      name: 'endtime',
      label: t('Completed Time'),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any) => {
          return value ? setTimeZone(value, 'Hongkong') : '-';
        },
      },
    },
    {
      name: 'sendReminder',
      label: t('Reminder'),
      options: {
        filter: false,
        sort: false,
      },
    },
  ]);

  return (
    <main
      style={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        background: `url(${LoginBg}) no-repeat center center`,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        position: 'inherit',
      }}
    >
      <Navigator />
      <div
        style={{
          display: 'flex',
          height: `calc(100% - ${NAVIGATOR_HEIGHT + COPYRIGHT_HEIGHT}px)`,
          width: '80%',
          flexDirection: 'column',
          paddingTop: '20px',
        }}
      >
        {/* Header Section */}
        <Grid container spacing={2} style={{ alignItems: 'center' }}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Box sx={courseTitle}>
              <Typography variant="h5" component="h2" className="course-h">
                {courseData.course ? courseData.course.category1 : ''} Report
              </Typography>
              <Button className="admin-btn" variant="contained">
                {t('Admin')}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Box sx={courseActions}>
              {/* <div style={{ position: 'relative' }}>
                <input className="course-search" type="text" onChange={e => handleFilter(e)} />
                <SearchOutlined
                  color="primary"
                  sx={{
                    position: 'absolute',
                    right: '10px',
                    top: '8px',
                    fontSize: '18px',
                  }}
                />
              </div> */}
              <Button
                sx={{
                  height: '34px',
                  textTransform: 'capitalize',
                }}
                variant="contained"
                onClick={() => { sendReminderEmail(); }}
              >
                {t('Send Reminder Email to Uncompleted Users')}
              </Button>
              <Button
                sx={{
                  width: '125px',
                  height: '34px',
                  textTransform: 'capitalize',
                }}
                variant="contained"
                startIcon={<i className="bi bi-arrow-return-left"></i>}
                onClick={() => { history.goBack(); }}
              >
                {t('Back')}
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Course Content Section  */}
        <Grid container spacing={2} mt={2} mb={8}>
          <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
            <Box sx={courseDetail}>
              {calculatePercentage()}
              <div style={{ display: 'flex', flexDirection: 'column', marginTop: '27px' }}>
                {handleExportAllReport()}
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
            <ThemeProvider theme={theme}>
              <ThemeProvider theme={getMuiTheme}>
                <MUIDataTable
                  title={' '}
                  data={filteredArr}
                  columns={columns}
                  options={options}
                />
              </ThemeProvider>
            </ThemeProvider>
          </Grid>
        </Grid>

      </div>
      <Copyright />
    </main>
  );
};

export default CourseReportListPage;
// 734
